import { useState } from "react";
import React from "react";
import MenuItem from "./MenuItem";
import '../../../../scss/partials/support/db/querycatalog/styles.css';

export default function MenuList({itemList, onToggleChildren}) {

  return (
    <ul className="menu-list-container text-deep-blue text-bold text-large">

      {itemList && itemList.length
        ? itemList.map((item) => <MenuItem key={item.id} item={item} onToggleChildren={onToggleChildren} />)
        : null}
    </ul>
  );
}